import { Component, OnInit } from "@angular/core";
import { FormField } from "src/app/interfaces/form-field.model";
import { WeeklyFocusDashboardService } from "src/app/services/sales/weekly-focus-dashboard.service";
import { Router } from "@angular/router";
import { NotifierService } from "angular-notifier";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'app-weekly-focus-dashboard-list',
  templateUrl: './weekly-focus-dashboard-list.component.html',
  styleUrls: ['./weekly-focus-dashboard-list.component.css'],
})
export class WeeklyFocusDashboardListComponent implements OnInit {
  faSearch = faSearch;

  upperFormFields: FormField[] = [
    {
      type: 'select',
      id: 'team',
      label: 'Team',
      options: [],
    },
    {
      type: 'select',
      id: 'salesman',
      label: 'Salesman',
      options: [],
    },
  ];

  tableHeaders = [
    { title: 'TITLE', type: 'link', id: 'WeeklyFocusTitle' },
    { title: 'SALES CONSULTANT', type: 'data', id: 'LoginId' },
    { title: 'CREATED DATE', type: 'data', id: 'CreatedDate' },
    { title: 'SUBMITTED DATE', type: 'data', id: 'SubmittedDate' },
    { title: 'REMARKS', type: 'data', id: 'UserRemark' },
    { title: 'ID', type: 'hidden', id: 'WeeklyFocusId' },
  ];
  tableEntries: any[] = [];

  selectedTeam: string = "";
  selectedSalesman: string = "";
  canSearch: boolean = false;

  constructor(
    private weeklyFocusService: WeeklyFocusDashboardService,
    private router: Router,
    private notifier: NotifierService,
  ) {}

  ngOnInit(): void {
    this.loadTeams();
  }
  
  loadTeams(): void {
    this.weeklyFocusService.getAllSalesTeamBasedOnPermission().subscribe(
      (response) => {
        if (response?.body?.length) {
          const teamOptions = response.body.map((team: any) => ({
              value: team.TeamName,
              display: team.TeamName,
            }));
          const teams = response.body.length > 1
            ? [{ value: "All", display: "ALL" }, ...teamOptions]
            : teamOptions;
          this.upperFormFields[0].options = teams;
          this.selectedTeam = teams[0].value;
          this.upperFormFields[0].value = this.selectedTeam;
          this.loadSalesmen(this.selectedTeam, true);
        } else {
          this.canSearch = false;
          this.tableEntries = [];
          this.notifier.notify(
            "error",
            "No sales teams are available for your permissions",
          );
        }
      },
      (error) => {
        console.error("Error loading teams:", error);
        this.notifier.notify("error", "Unable to load sales teams");
      },
    );
  }
  
  loadSalesmen(team: string, searchAfterLoad = false): void {
    this.canSearch = false;
    this.weeklyFocusService.getAllSalesmanBasedOnTeam(team).subscribe(
      (response) => {
        if (response?.body?.length) {
          const salesmanOptions = response.body.map((salesman: any) => ({
              value: salesman.SalesmanCode,
              display: `${salesman.SalesmanDesc} (${salesman.SalesmanCode})`,
            }));
          const salesmen = response.body.length > 1
            ? [{ value: "All", display: "ALL" }, ...salesmanOptions]
            : salesmanOptions;
          this.upperFormFields[1].options = salesmen;
          this.selectedSalesman = salesmen[0].value;
          this.upperFormFields[1].value = this.selectedSalesman;
          this.canSearch = true;
          if (searchAfterLoad) {
            this.loadWeeklyFocus(
              this.selectedTeam,
              this.selectedSalesman,
            );
          }
        } else {
          this.upperFormFields[1].options = [];
          this.upperFormFields[1].value = undefined;
          this.selectedSalesman = "";
          this.tableEntries = [];
        }
      },
      (error) => {
        console.error("Error loading salesmen:", error);
        this.notifier.notify("error", "Unable to load salesmen");
      },
    );
  }
  
  loadWeeklyFocus(team: string, salesman: string): void {
    this.weeklyFocusService.getAllWeeklyFocus(
      team,
      salesman,
    ).subscribe(
      (response) => {
        if (response?.body) {
          this.tableEntries = response.body.map((item: any) => ({
            WeeklyFocusTitle: item.WeeklyFocusTitle || '',
            LoginId: item.LoginId || '',
            CreatedDate: item.CreatedDate || '',
            SubmittedDate: item.SubmittedDate || '',
            UserRemark: item.UserRemark || "",
            WeeklyFocusId: item.WeeklyFocusId || '',
          }));
        } else {
          this.tableEntries = [];
        }
      },
      (error) => {
        console.error('Error loading weekly focus:', error);
        this.tableEntries = [];
        this.notifier.notify(
          "error",
          "Unable to load Weekly Focus records",
        );
      }
    );
  }
  
  handleUpdate(event: any): void {
    const changedField = event.fields[event.updatedValue];
    if (changedField?.id === "team") {
      this.selectedTeam = changedField.value;
      this.loadSalesmen(this.selectedTeam);
    } else if (changedField?.id === "salesman") {
      this.selectedSalesman = changedField.value;
    }
  }

  search(): void {
    if (!this.canSearch) {
      return;
    }
    this.loadWeeklyFocus(this.selectedTeam, this.selectedSalesman);
  }

  openEntry(value: any): void {
    this.router.navigate([
      "/sales/weekly-focus-dashboard",
      value.WeeklyFocusId,
    ]);
  }  
}
